import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-pill border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus-visible:outline-2 focus-visible:outline-focus",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-inverse text-inverse-foreground",
        secondary:
          "border-transparent bg-mist text-foreground",
        destructive:
          "border-transparent bg-brick-soft text-brick",
        outline: "border-line-strong text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
